<mat-toolbar color="primary" class="toolbar">
  <img
    src="../assets/logo.png"
    class="logo flex-it"
    [routerLink]="[APP_ROUTES.ROOT]"
  />

  @if (decodedToken?.platform_admin) {
    <span class="platform-admin-badge">Platform Admin</span>
  }
  <!--Toolbar Buttons-->
  @if (workspace) {
    <button
      mat-button
      class="toolbar-selector"
      [matMenuTriggerFor]="workspaceMenu"
    >
      {{ workspace.label }}
      <ng-icon name="HeroChevronDownSolid"></ng-icon>
    </button>
  }
  <span class="toolbar-fill"></span>

  <!--Workspace Button Menu-->
  <mat-menu #workspaceMenu="matMenu">
    @if (myWorkspaces.length > 0) {
      <div class="workspace-menu-label" mat-menu-item disabled>
        My Workspaces
      </div>
      @for (workspace of myWorkspaces; track workspace.uuid) {
        <button mat-menu-item (click)="activateWorkspace(workspace)">
          {{ workspace.label }}
        </button>
      }
    }
    @if (otherWorkspaces.length > 0) {
      @if (myWorkspaces.length > 0) {
        <mat-divider></mat-divider>
      }
      <div class="workspace-menu-label" mat-menu-item disabled>
        Other Workspaces
      </div>
      @for (workspace of otherWorkspaces; track workspace.uuid) {
        <button mat-menu-item (click)="activateWorkspace(workspace)">
          {{ workspace.label }}
        </button>
      }
    }
    @if (myWorkspaces.length > 0 || otherWorkspaces.length > 0) {
      <mat-divider></mat-divider>
    }
    <button mat-menu-item (click)="newWorkspace()">
      <div class="flex-it flex-row flex-xcontent-center">
        <ng-icon name="HeroPlusSolid" class="nav-ng-icon add-icon"></ng-icon>
        <span>New workspace</span>
      </div>
    </button>
  </mat-menu>

  <!--Notifications-->
  <button
    mat-icon-button
    matTooltip="Notifications"
    [matMenuTriggerFor]="notificationMenu"
  >
    <div
      class="notification-badge-anchor"
      [matBadge]="unviewedNotifications"
      [matBadgeHidden]="!unviewedNotifications"
      matBadgeColor="accent"
      matBadgeSize="small"
    ></div>
    <ng-icon
      [name]="unviewedNotifications > 0 ? 'HeroBellSolid' : 'HeroBell'"
      class="nav-ng-icon"
      [attr.aria-label]="
        unviewedNotifications > 0 ? 'You have notifications' : null
      "
      [attr.aria-hidden]="unviewedNotifications > 0 ? null : 'true'"
    ></ng-icon>
  </button>
  <mat-menu #notificationMenu="matMenu" (closed)="markNotificationsViewed()">
    @if (workspace) {
      @for (n of notifications$ | async; track n) {
        @switch (n.type) {
          <!--File Ready-->
          @case (PersistentNotificationType.FILE_READY) {
            <div
              class="notification"
              [class.viewed]="n.viewed"
              [routerLink]="[
                APP_ROUTES.WORKSPACE,
                workspace.name,
                WORKSPACE_ROUTES.DOWNLOADS,
              ]"
            >
              <div class="notification-type">{{ n.type }}</div>
              <div class="notification-date">
                {{ n.created | date: "medium" }}
              </div>
              <div class="notification-info">File: {{ n.data.file_name }}</div>
            </div>
          }
          <!--Default-->
          @default {
            <div class="notification" [class.viewed]="n.viewed">
              <div class="notification-type">{{ n.type }}</div>
              <div class="notification-date">
                {{ n.created | date: "medium" }}
              </div>
            </div>
          }
        }
      }
    }
  </mat-menu>

  <!--Provision User Button-->
  @if (decodedToken?.master) {
    <button
      mat-icon-button
      matTooltip="Provision new user"
      [routerLink]="[APP_ROUTES.PROVISION_USER]"
    >
      <ng-icon name="HeroUserAdd" class="nav-ng-icon"></ng-icon>
    </button>
  }

  <!--User Button-->
  <button mat-icon-button [matMenuTriggerFor]="userMenu" matTooltip="Settings">
    <ng-icon name="HeroCog" class="nav-ng-icon"></ng-icon>
  </button>
  <label
    class="dark-mode-toggle-button"
    matTooltip="Dark Mode"
    for="dark-mode-toggle"
    aria-label="Toggle dark mode"
  >
    <input
      id="dark-mode-toggle"
      class="dark-mode-toggle"
      type="checkbox"
      [(ngModel)]="isDarkMode"
      (change)="toggleDarkMode()"
    />
  </label>

  <!--User Button Menu-->
  <mat-menu #userMenu="matMenu">
    <button mat-menu-item [routerLink]="[APP_ROUTES.USER]">
      Account Settings
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="logout()">Logout</button>
  </mat-menu>
</mat-toolbar>

<div class="routing-container">
  <router-outlet></router-outlet>
</div>
